import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DetectionStateComponent } from '../detection-state/detection-state.component';
import { VehicleIcconResumeComponent } from '../vehicle-iccon-resume/vehicle-iccon-resume.component';
import { AccessService } from '../../services/http/access/access.service';
import { Vehicle, VehiclesResponse } from '../../services/http/vehicles/vehicles.interface';
import { VehiclesService } from '../../services/http/vehicles/vehicles.service';
import { LoaderService } from '../../services/loader/loader.service';
import { AccessVehicleResponse } from '../../services/http/access/access.interface';

@Component({
  selector: 'app-access',
  standalone: true,
  imports: [CommonModule, FormsModule, DetectionStateComponent, VehicleIcconResumeComponent],
  templateUrl: './access.component.html',
  styleUrl: './access.component.scss'
})
export class AccessComponent {
  @Input() applicantId: string = '';
  @Output() clickNewVehicle = new EventEmitter<void>();

  yearSelected = new Date().getFullYear();
  years = Array.from({ length: new Date().getFullYear() - 2022 }, (v, k) => k + 2023);
  vehicles: Vehicle[] = [];
  vehicleSelected: Vehicle | null = null;
  accessList: AccessVehicleResponse | null = null;
  noAccessText = "";

  total = 0;
  limit = 7;

  error = "";

  constructor(
    private readonly vehiclesService: VehiclesService,
    private readonly accessService: AccessService,
    private readonly loaderService: LoaderService
  ) {}

  ngAfterViewInit() {
    if (this.applicantId) {
      this.loaderService.show();
      this.vehiclesService.getVehicleesByApplicant(this.applicantId, this.limit).subscribe((data: VehiclesResponse) => {
        this.vehicles = data.elements;
        this.total = data.total;
        this.loaderService.hide();
      });
    }
  }

  loadMore() {
    this.loaderService.show();
    this.vehiclesService.getVehicleesByApplicant(this.applicantId, this.limit, this.vehicles.length).subscribe((data: VehiclesResponse) => {
      this.vehicles = this.vehicles.concat(data.elements);
      this.loaderService.hide();
    });
  }

  loadAcceses() {
    if (!this.vehicleSelected) {
      return;
    }
    this.error = "";
    this.loaderService.show();
    this.accessService.getAccessesByVehicleAndApplicant(this.vehicleSelected.vehiclePlate, this.applicantId, this.yearSelected).subscribe((accessesList) => {
      this.accessList = accessesList;
      if (this.accessList.municipalities.length == 0) {
        this.noAccessText = $localize`:@@access.error:No se encontraron accesos para el vehículo seleccionado.`;
        setTimeout(() => {
          document.getElementById("noAccessText")?.scrollIntoView({ behavior: 'smooth' });
          this.loaderService.hide();
        }, 100);
      } else {
        this.noAccessText = "";
        setTimeout(() => {
          document.getElementById("accesos")?.scrollIntoView({ behavior: 'smooth' });
          this.loaderService.hide();
        }, 100);
      }
    }, (error) => {
      if (error.status === 400) {
        this.error = error.error.message;
        setTimeout(() => {
          document.getElementById("error")?.scrollIntoView({ behavior: 'smooth' });
          this.loaderService.hide();
        }, 100);
      }
    });
  }

  newVehicle() {
    this.clickNewVehicle.emit();
  }

  selectVehicle(vehicle: Vehicle) {
    this.vehicleSelected = vehicle;
    this.loadAcceses();
  }

  getClass(percentaje: number) {
    if (percentaje < 60) {
      return 'bg-success';
    } else if (percentaje < 80) {
      return 'bg-warning';
    } else {
      return 'bg-danger';
    }
  }
}
